import { useEffect, useState } from 'react';
import { profilingEndpoints, IStepResolved } from '../../../../endpoints/profiling';

/**
 * Risolve una singola intensità a step (% di VAM/VIFT/FTP) nel valore assoluto
 * del singolo atleta, per la PREVIEW nel builder (BUG E). Non bloccante:
 * - attivo solo se c'è un atleta di anteprima + ref + pct numerico
 * - debounce 400ms per non martellare il backend mentre si digita
 * - riusa l'endpoint server `POST /profiling/conditioning/resolve` (stessa
 *   logica della risoluzione downstream, niente formule duplicate sul client).
 */
export function useConditioningResolve(
  previewAthleteId: string | undefined,
  ref: string | undefined,
  pct: string | undefined,
): { resolved: IStepResolved | null; loading: boolean } {
  const [resolved, setResolved] = useState<IStepResolved | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const pctNum = pct ? parseFloat(pct) : NaN;
    if (!previewAthleteId || !ref || !Number.isFinite(pctNum)) {
      setResolved(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const { data } = await profilingEndpoints.resolveConditioning({
          athleteId: previewAthleteId,
          steps: [
            { kind: 'single', volumeMode: 'time', volumeValue: 0, intensity: { ref, pct: pctNum } },
          ],
        });
        if (!cancelled) setResolved(data?.steps?.[0]?.intensity?.resolved ?? null);
      } catch {
        if (!cancelled) setResolved(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 400);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [previewAthleteId, ref, pct]);

  return { resolved, loading };
}
